import { formatDataToSend, filterConstantsToSend, removeUndefinedFromObject } from './utils.js';

const gtmEvent = ({
  hash,
  eventType,
  userData,
  data,
  dimensions
}) => {
  const formattedData = formatDataToSend({ userData, assetData: data });
  let originalDimensions = {};
  originalDimensions = dimensions?.length > 0 ? filterConstantsToSend(dimensions, formattedData) : formattedData;
  const constantToSend = removeUndefinedFromObject(originalDimensions);
  const dataLayer = {
    hash,
    event: eventType,
    ...constantToSend
  };
  if (window.dataLayer)
    window.dataLayer.push(dataLayer);
};

export { gtmEvent };
//# sourceMappingURL=gtmEvent.js.map
